import { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { captureException } from "@sentry/react";

import ContestResults from "./ContestResults";

export default () => {
  const [page, setPage] = useState(1);

  // Fetch data
  const limit = 20;

  const GET_CONTEST_RESULTS_DATA = gql`
    query GetContestResultsData($week: Int, $page: Int!, $limit: Int!) {
      contestResults(week: $week, page: $page, limit: $limit) {
        startsAt
        endsAt
        prizePool
        results {
          rank
          username
          points
          prize
        }
        numOfResults
      }
    }
  `;

  const { data, error } = useQuery(GET_CONTEST_RESULTS_DATA, {
    variables: {
      week: 0,
      page,
      limit,
    },
  });

  if (error) {
    console.log("fetching contest results data error", error);
    captureException(error);
  }

  const paginate = (where) => {
    if (where === "previous") setPage((prevState) => prevState - 1);
    if (where === "next") setPage((prevState) => prevState + 1);
  };

  //console.log({ data });

  return (
    <ContestResults data={data} limit={limit} page={page} paginate={paginate} />
  );
};
